import Button from "../sharedComponents/buttons/button";
const ErrorScreen = (message, code, setTryAgain) => {
  return (
    <div className=" d-flex flex-column justify-content-center align-items-center">
      <div style={{ fontSize: 45, color: "gray" }}>{code}</div>
      <div style={{ fontSize: 25 }}>{message}</div>
      {setTryAgain ? (
        <Button
          onClick={() => {
            setTryAgain();
          }}
          content={"Try Again"}
        />
      ) : null}
    </div>
  );
};

export default ErrorScreen;
